/**
 * XFrame utilities.
 * DOM origin: "http://www.touchcommerce.com" (for example)
 * @author Fred A. Pinn (fpinn@TouchCommerce.com)
 */
/**
 * package: com.inq.flash.client.control
 * class: XFrameWorker
 * root Object
 * @constructor
 */
com.inq.flash.client.control.XFrameWorker = function() {};
$hxClasses.registerClass(com.inq.flash.client.control.XFrameWorker, 'com.inq.flash.client.control.XFrameWorker');


/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.XFrameWorker.init = function() {
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.setEngageParameters",com.inq.flash.client.control.XFrameWorker.setEngageParameters);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.engageChat",com.inq.flash.client.control.XFrameWorker.engageChat);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.isChatConnected",com.inq.flash.client.control.XFrameWorker.isChatConnected);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.showLayer",com.inq.flash.client.control.XFrameWorker.showLayer);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.hideLayer",com.inq.flash.client.control.XFrameWorker.hideLayer);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.grow",com.inq.flash.client.control.XFrameWorker.grow);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.shrink",com.inq.flash.client.control.XFrameWorker.shrink);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.showLayerXcd",com.inq.flash.client.control.XFrameWorker.showLayerXcd);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.isLayerVisible",com.inq.flash.client.control.XFrameWorker.isLayerVisible);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.fireCustomEvt",com.inq.flash.client.control.XFrameWorker.fireCustomEvt);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.showAutomatonXcd",com.inq.flash.client.control.XFrameWorker.showAutomatonXcd);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.hideLayerAndEndChat",com.inq.flash.client.control.XFrameWorker.hideLayerAndEndChat);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.growXcd",com.inq.flash.client.control.XFrameWorker.growXcd);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.preparingClosingChat",com.inq.flash.client.control.XFrameWorker.preparingClosingChat);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.closeChat",com.inq.flash.client.control.XFrameWorker.closeChat);
	// Short name for closeChat which is exposed to client.
	com.inq.utils.Util.publish("window.inqFrame.closeChat",com.inq.flash.client.control.XFrameWorker.closeChat);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.setAutomatonDataMapXcd",com.inq.flash.client.control.XFrameWorker.setAutomatonDataMapXcd);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.isDisplayInCI",com.inq.flash.client.control.XFrameWorker.isDisplayInCI);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.resizeStage",com.inq.flash.client.control.XFrameWorker.resizeStage);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.moveStage",com.inq.flash.client.control.XFrameWorker.moveStage);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.syncLayer",com.inq.flash.client.control.XFrameWorker.syncLayer);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.XFrameWorker.onCookiesCommitted",com.inq.flash.client.control.XFrameWorker.onCookiesCommitted);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.MinimizeManager.actionMinimize",com.inq.flash.client.control.MinimizeManager.actionMinimize);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.MinimizeManager.actionRestore",com.inq.flash.client.control.MinimizeManager.actionRestore);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.MinimizeManager.isMinimized",com.inq.flash.client.control.MinimizeManager.isMinimized);
	/* Per prechat survey develop team's request, and long package name cost search time, the exposed name has been reduced.
	 * We should rearrange all package names soon.
	 */
	com.inq.utils.Util.publish("window.inqFrame.XFrameWorker.setCircularModalWindow", com.inq.flash.client.control.XFrameWorker.setCircularModalWindow);
	com.inq.utils.Util.publish("window.inqFrame.XFrameWorker.setCircularApplication", com.inq.flash.client.control.XFrameWorker.setCircularApplication);
	com.inq.utils.Util.publish("window.inqFrame.XFrameWorker.removeCircularModalWindow", com.inq.flash.client.control.XFrameWorker.removeCircularModalWindow);
	com.inq.utils.Util.publish("window.inqFrame.XFrameWorker.isCircularTabbingEnabled", com.inq.flash.client.control.XFrameWorker.isCircularTabbingEnabled);

	/**
	 * when automation change the screen
	 */
	com.inq.utils.Util.publish("window.inqFrame.XFrameWorker.transitionPage", com.inq.flash.client.control.XFrameWorker.transitionPage);

	// com.inq.net.URLLoader._httpRequestHandler need to be published here or it won't be found in L3
	com.inq.utils.Util.publish("window.inqFrame.com.inq.net.URLLoader._httpRequestHandler",com.inq.net.URLLoader._httpRequestHandler);

	com.inq.flash.client.control.XFrameWorker.xframeLoadingIntIdCount = 0;
	com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId = -1;

	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.sendSystemMessage", com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendSystemMessage);

	com.inq.utils.Util.publish("ciSendText",com.inq.flash.client.chatskins.SkinControl.actionBtnSend);

	/**
	 * get saved state for layers
	 * Iterate through all the container IDs saved in "xf" and set visibility state
	 * "1" - showLayer
	 * "0" - hideLayer
	 */
	/** @type {Object} */
	var xf = com.inq.flash.client.control.PersistenceManager.GetValue(XFRAMES,{ });
	/** @type {Array} */
	var keyz = Reflect.fields(xf);
	/** @type {string} */
	var layerID;
	/** @type {boolean} */
	var show;
	haxe.Log.trace("XFrameWorker.init(): restoring saved state for " + keyz.length + " layer(s).", {
		fileName: "XFrameWorker.hx",
		lineNumber: 46,
		className: "com.inq.flash.client.control.XFrameWorker",
		methodName: "init"
	});
	for (var i = 0; i < keyz.length; i++) {
		layerID = keyz[i];
		show = "1" == xf[layerID];
		if (show) {
			com.inq.flash.client.control.XFrameWorker.showLayer(layerID);
		} else {
			com.inq.flash.client.control.XFrameWorker.hideLayer(layerID);
		}
	}
	com.inq.flash.client.control.XFrameWorker.doIFrameNotification = com.inq.utils.Util.getConfig("iFrameCanvasClosedMessage", com.inq.flash.client.control.XFrameWorker.doIFrameNotification);
	com.inq.flash.client.control.XFrameWorker.doIFrameNotificationToAgent = com.inq.utils.Util.getConfig("iFrameCanvasClosedMessageToAgent", com.inq.flash.client.control.XFrameWorker.doIFrameNotificationToAgent);
	return true;
};


/**
 * isLayerVisible
 * Returns true if specified layer is visible.
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * public static function isLayerVisible(layerID:String):Bool
 * @public
 * @static
 * @param {string}  layerID -  id of layer to check
 * @return {boolean}
 */
com.inq.flash.client.control.XFrameWorker.isLayerVisible = function(layerID) {
	/** @type {boolean} */
	var visible = false;
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication(layerID)) {
		/** @type {com.inq.ui.Container} */
		var cntr = Application.application.getMxmlItem(layerID);
		if(cntr.getStyle("visible") == "true") visible = true;
	} else haxe.Log.trace("XFrameWorker.isLayerVisible('" + layerID + "', ...): layer is not in the application",{ fileName : "XFrameWorker.hx", lineNumber : 68, className : "com.inq.flash.client.control.XFrameWorker", methodName : "isLayerVisible", customParams : ["warn"]});
	return visible;
};


com.inq.flash.client.control.XFrameWorker.showVideoLayer = function (layerID, noOpeners, url, businessUnitID, updateCookies, initiator, params) {
	var p = params.split(",");
	var cntr = Application.application.getMxmlItem(layerID);
	try {
		if (js.Boot.__instanceof(cntr, com.inq.ui.VideoPlayer)) {
			item.setupArgs(p);
		}
		else {
			var childs = cntr._div && cntr._div.children, item, id, len;
			len = childs.length;
			for (var i = 0; i < len; i++) {
				id = childs[i].id;
				if (id) {
					if (id.indexOf("tcChat_") != -1) {
						id = id.substring(7);
					}
					item = Application.application.getMxmlItem(id);
					if (js.Boot.__instanceof(item, com.inq.ui.VideoPlayer)) {
						item.setupArgs(p);
					}
				}
			}
		}
		if (cntr.getVisible() && item) {
			item.play();
		} else {
			com.inq.flash.client.control.XFrameWorker.showLayer(layerID, noOpeners, url, businessUnitID, updateCookies, initiator);
		}
	}
	catch (e) {

	}
};

com.inq.flash.client.control.XFrameWorker.showIFrameLayer = function (layerID, noOpeners, url, businessUnitID, updateCookies, initiator, params) {
	var cntr = Application.application.getMxmlItem(layerID);
	try {
		if (cntr && cntr._div) {
			Application.application.sendMessageWhenShowHideLayerFlag = true;
			com.inq.flash.client.control.XFrameWorker.showLayer(layerID, noOpeners, url, businessUnitID, updateCookies, initiator);
		}
	}
	catch (e) {

	}
};

/**
 * showLayer
 * Shows specified layer when chat is not minimized status.
 *
 * @public
 * @static
 * @param {string}  layerID -  id of layer to show
 * @param {boolean}  noOpeners -  optional param
 * @param {string}  url -  optional param specifying XFrame source
 * @param {string}  businessUnitID -  optional param, may be specified if this method is called by a biz rule
 * @param {boolean}  updateCookies -  optional param, whether to update cookies (for optimization of multiple show/hide layer operations).
 * @param {object} initiator - type ('br', 'agent' or 'automaton') and id of initiator who show automaton
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.showLayer = function (layerID, noOpeners, url, businessUnitID, updateCookies, initiator) {
    var panelHandler =  com.inq.flash.client.chatskins.SkinControl.initializePanelHandler(layerID, true);
	if(updateCookies == null) updateCookies = true;
	if(noOpeners == null) noOpeners = false;
	haxe.Log.trace("XFrameWorker.showLayer(" + layerID + ", " + Std.string(noOpeners) + ", " + url + ", " + businessUnitID + ", " + Std.string(updateCookies) + ") entered",{ fileName : "XFrameWorker.hx", lineNumber : 84, className : "com.inq.flash.client.control.XFrameWorker", methodName : "showLayer"});
	/** @type {com.inq.ui.Container} */
	var cntr;
	// /** @type {number} */
	var deltaHeight = 0;
	/** @type {?number} */
	var deltaWidth = 0;
	if (com.inq.flash.client.chatskins.SkinControl.isInApplication(layerID)) {
		cntr = Application.application.getMxmlItem(layerID);
		if(null != cntr) {
			if(url != null) {
				if(js.Boot.__instanceof(cntr,com.inq.ui.XFrame)) {
					var data = com.inq.flash.client.control.FlashPeer.parseXFrameUrl(url);
					data["initiator"] = initiator;
					cntr.setSrcWithBusinessUnitID(data, businessUnitID);
					cntr.persistURL();
				} else {
					cntr.setIFrameSrc(url);
				}
			} else {
				cntr.updateSrc(businessUnitID, initiator);
			}
			/* Adding parameters to URL */
			cntr.loadContent();
			if(cntr.getStyle("visibility") == "collapse") {
				/* Restore the collapsed height/width */
				try {
					deltaWidth = Std.parseInt(cntr.getStyle("ucW"));
				} catch( e ) {
					deltaWidth = 0;
				}
				try {
					deltaHeight = Std.parseInt(cntr.getStyle("ucH"));
				} catch( e ) {
					deltaHeight = 0;
				}
				/* If the skin was collapsed in the MXML then we need to use the height/width from the MXML */
				if(deltaWidth == null) try {
					deltaWidth = Std.parseInt(cntr.getStyle("width"));
				} catch( e ) {
					deltaWidth = 0;
				}
				if(deltaHeight == null) try {
					deltaHeight = Std.parseInt(cntr.getStyle("height"));
				} catch( e ) {
					deltaWidth = 0;
				}
				/* If null then the settings for height or ucH, or width or ucW were not defined, default to zero */
				if(deltaWidth == null) deltaWidth = 0;
				if(deltaHeight == null) deltaHeight = 0;
				cntr.setStyle("visibility","visible");
				cntr.setStyle("visible","true");
				cntr.setVisible(true);
				com.inq.flash.client.control.XFrameWorker.setPersistentState(layerID,true,updateCookies);
				Application.application.resize();
			} else if(cntr.getStyle("visible") == "false") {
				cntr.setStyle("visible","true");
				cntr.setVisible(true);
				com.inq.flash.client.control.XFrameWorker.setPersistentState(layerID,true,updateCookies);
			}
		}
	} else haxe.Log.trace("XFrameWorker.showLayer('" + layerID + "', ...): layer is not in the application",{ fileName : "XFrameWorker.hx", lineNumber : 128, className : "com.inq.flash.client.control.XFrameWorker", methodName : "showLayer", customParams : ["warn"]});

	/**
	 *  MOB-830
	 *  putting this function outside because it need to check in any case cWindow.hasAttribute("data-disabled")
	 *  if it has the attribute then input area and send button should be enabled
	 */
	com.inq.flash.client.control.XFrameWorker.enableChatWindow();
	if(layerID == "Chat") {
		haxe.Log.trace("XFrameWorker.showLayer: SkinControl.kickOffChat", { fileName: "XFrameWorker.hx", lineNumber: 131, className: "com.inq.flash.client.control.XFrameWorker", methodName: "showLayer"});
		com.inq.flash.client.chatskins.SkinControl.kickOffChat(noOpeners);
		haxe.Log.trace("XFrameWorker.showLayer: SkinControl.fireMxmlHandler(onShowChat)", { fileName: "XFrameWorker.hx", lineNumber: 133, className: "com.inq.flash.client.control.XFrameWorker", methodName: "showLayer"});

		com.inq.flash.client.chatskins.SkinControl.fireMxmlHandler("onShowChat");
	} else if(layerID == "chat") {
		/*
		 * RTDEV-19868
		 * Modified to pass "true" to setFocusOnInputField for phone devices so that the Send button will be selected
		 * when the chat ui is launched.
		 */
		if(com.inq.utils.Capabilities.isPhone()) {
			com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField(true);
		} else {
			com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField();
		}
	} else if (layerID === "switch") {
		/*
		 * RTDEV-19523
		 * Disable screen reader from reading the information on the chat page such as the buttons on the titlebar
		 * and the chatfooter.
		 * This will be restored when the user closes the "switch" page and restores to the chat.
		 */
		com.inq.aria.AriaMsg.disableScreenReaderForChat();
		var rtcBtn = Application.application.getButton("btnReturnToChatA");
		if (rtcBtn && rtcBtn._img) {
			rtcBtn._img.focus();
		}

	} else if (com.inq.utils.Capabilities.isPhone()) {
		/*
		 * RTDEV-19655
		 * This problem applies to both iphone and android phones.
		 * Find the active INPUT or TEXTAREA that raise the keyboard and blur it to hide the keyboard.
		 */
		var activeElm = parent.document.activeElement;
		if (activeElm && (activeElm.tagName == "INPUT" || activeElm.tagName == "TEXTAREA")) {
			activeElm.blur();
		}
		if (com.inq.utils.Capabilities.isIphone() && com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur();
		}
	}
    com.inq.flash.client.chatskins.SkinControl.fixChatOnPanelOpenClose(layerID, true, panelHandler);
};

/**
 *  enabled the chat window after the user navigates to chat layer from guide layer
 */

com.inq.flash.client.control.XFrameWorker.enableChatWindow = function()
{
	var cWindow = com.inq.ui.Container._getElementById("tcChat_chatWindow",parent.document);
	if(cWindow && cWindow.hasAttribute("data-disabled"))
	{
		com.inq.flash.client.chatskins.SkinControl.getInputArea().setVisible(true);
		com.inq.flash.client.chatskins.SkinControl.getSendButton().setVisible(true);
		cWindow.removeAttribute("aria-hidden");
		cWindow.removeAttribute("data-disabled");
	}
}

/**
 * showLayerXcd
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => updateCookies, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public static function showLayerXcd(layerID:String, updateCookies:Bool):Void
 * @public
 * @static
 * @param {string}  layerID
 * @param {boolean}  updateCookies
 * @param {string} automatonId automaton id that run command
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.showLayerXcd = function (layerID, updateCookies, automatonId) {
	var initiator = {type: 'automaton', id: automatonId};
	com.inq.flash.client.control.XFrameWorker.showLayer(layerID, false, null, null, updateCookies, initiator);
};

/**
 * Show automaton in specified container. Calling from automaton.
 * @param automatonId automaton id that call this command
 * @param layerID container id
 * @param url automaton request url
 * @param updateCookies optional param, whether to update cookies (for optimization of multiple show/hide layer operations).
 */
com.inq.flash.client.control.XFrameWorker.showAutomatonXcd = function (automatonId, layerID, url, updateCookies) {
	var initiator = {type: 'automaton', id: automatonId};
	com.inq.flash.client.control.XFrameWorker.showLayer(layerID, false, url, null, updateCookies, initiator);
};


/**
 * fireCustomEvt
 * Fires custom events with data instance and data object support. This is a more complete execution of the above method.
 *
 * $type TFun([{ name => eventName, t => TInst(String,[]), opt => false },{ name => jsonData, t => TInst(String,[]), opt => false },{ name => dataFcn, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function fireCustomEvt(eventName:String, jsonData:String, dataFcn:String):Void
 * @public
 * @static
 * @param {string}  eventName -  {String} The name of the custom event to be invoked. 
 * @param {string}  jsonData -  {String} Optional jsonized data string. Will be parsed into an object and passed to the EVM. 
 * @param {string}  dataFcn -  {String} Optional stringified function to be JSON parsed and executed by the event manager to produce event data. 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.fireCustomEvt = function(eventName,jsonData,dataFcn) {
	if(dataFcn != null && dataFcn == "") dataFcn = null;
	com.inq.flash.client.control.FlashPeer.fireCustomEvt(eventName,jsonData,dataFcn);
};


/**
 * hideLayer
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => updateCookies, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function hideLayer(layerID:String, ?updateCookies:Bool=true):Void
 * @public
 * @static
 * @param {string}  layerID 
 * @param {boolean}  updateCookies 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.hideLayer = function(layerID,updateCookies) {

	var panelHandler =  com.inq.flash.client.chatskins.SkinControl.initializePanelHandler(layerID, false);
	if(updateCookies == null) updateCookies = true;
	haxe.Log.trace("XFrameWorker.hideLayer(" + layerID + ", " + Std.string(updateCookies) + ") entered",{ fileName : "XFrameWorker.hx", lineNumber : 156, className : "com.inq.flash.client.control.XFrameWorker", methodName : "hideLayer"});
	/** @type {com.inq.ui.Container} */
	var cntr;
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication(layerID)) {
		cntr = Application.application.getMxmlItem(layerID);
		var sW,sH;
		if(com.inq.flash.client.control.FlashPeer.noV3FrameChat()){
			sH = Application.application.stg.style.height;
			sW = Application.application.stg.style.width;
		} else {
			sH = window.frameElement.style.height;
			sW = window.frameElement.style.width;
		}
		/** @type {number} */

		var stageHeight = Std.parseInt(sH);
		/** @type {number} */ 
		var stageWidth = Std.parseInt(sW);
        cntr.initStyle("visibility", "collapse");
		if (Application.application.sendMessageWhenShowHideLayerFlag === true) {
			com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendSystemMessage(com.inq.flash.client.control.XFrameWorker.doIFrameNotification);
			Application.application.sendMessageWhenShowHideLayerFlag = false;
		}
		if (!com.inq.flash.client.control.MinimizeManager.isMinimized()) {
			Application.application.resize();
		}
		/** @type {number} */ 
		var deltaWidth = stageWidth - Std.parseInt(sW);
		/** @type {number} */ 
		var deltaHeight = stageHeight - Std.parseInt(sH);
        cntr.initStyle("ucH", "" + deltaHeight);
        cntr.initStyle("ucW", "" + deltaWidth);
        com.inq.flash.client.control.XFrameWorker.setPersistentState(layerID, false, updateCookies);
        cntr.fireHidden();
        cntr._visible = false;
		/*
		 * RTDEV-19523
		 * Re-enable screen reader for chat. This function is invoked when the agent clicks the "Hide Switch" button
		 * on AI.
		 */
		if (layerID === "switch") {
			com.inq.aria.AriaMsg.restoreScreenReaderForChat();
		}
	} else haxe.Log.trace("XFrameWorker.hideLayer('" + layerID + "', ...): layer is not in the application",{ fileName : "XFrameWorker.hx", lineNumber : 170, className : "com.inq.flash.client.control.XFrameWorker", methodName : "hideLayer", customParams : ["warn"]});
    com.inq.flash.client.chatskins.SkinControl.fixChatOnPanelOpenClose(layerID, false, panelHandler);
};


/**
 * hideLayerAndEndChat
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => updateCookies, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function hideLayerAndEndChat(layerID:String, ?updateCookies:Bool=true):Void
 * @public
 * @static
 * @param {string}  layerID 
 * @param {boolean}  updateCookies 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.hideLayerAndEndChat = function(layerID,updateCookies) {
	if(updateCookies == null) updateCookies = true;
	haxe.Log.trace("hideLayerAndEndChat entered",{ fileName : "XFrameWorker.hx", lineNumber : 176, className : "com.inq.flash.client.control.XFrameWorker", methodName : "hideLayerAndEndChat"});
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_AUTOMATON);
	if(layerID.toUpperCase() == "ROOT") {
	} else 
	com.inq.flash.client.control.XFrameWorker.hideLayer(layerID,updateCookies);
};


/**
 * grow
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => url, t => TInst(String,[]), opt => true },{ name => updateCookies, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function grow(layerID:String, ?url:String, ?updateCookies:Bool=true):Void
 * @public
 * @static
 * @param {string}  layerID 
 * @param {string}  url 
 * @param {boolean}  updateCookies
 * @param initiator initiator who show automaton
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.grow = function (layerID, url, updateCookies, initiator) {
    var panelHandler =  com.inq.flash.client.chatskins.SkinControl.initializePanelHandler(layerID, true);
	if(updateCookies == null) updateCookies = true;
	/** @type {com.inq.ui.Container} */ 
	var cntr;
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication(layerID)) {
		cntr = Application.application.getMxmlItem(layerID);
		if(url != null) {
			if(js.Boot.__instanceof(cntr,com.inq.ui.XFrame)) {
				var data = com.inq.flash.client.control.FlashPeer.parseXFrameUrl(url);
				data["initiator"] = initiator;
				cntr.setSrcWithBusinessUnitID(data, null);
				cntr.persistURL();
			} else {
				cntr.setSrc(url);
			}
		} else {
			cntr.updateSrc(null, initiator);
		}

		var msgVideoOpen = com.inq.utils.Util.getConfig("msgVideoOpen", ""); /* @type {string} */
		msgVideoOpen = msgVideoOpen.replace("{accesskey}", getBrowserAccessKey());

		com.inq.aria.AriaMsg.addAriaMsg(msgVideoOpen);

		cntr.loadContent();
		/** @type {number} */
		var growDeltaX = 0;
		/** @type {number} */
		var growDeltaY = 0;
		if(cntr.getStyle("visibility") == "collapse") {
			cntr.setStyle("visibility","visible");
			cntr.setStyle("visible","true");
			cntr.setVisible(true);
			/** @type {?string} */
			var st = cntr.getStyle("height");
			if(st != null && st != "") growDeltaY = cntr.getHeight();
			st = cntr.getStyle("width");
			if(st != null && st != "") growDeltaX = cntr.getWidth();
		}
		/** @type {number} */
		var stageHeight = com.inq.ui.Stage.getterStageHeight() + growDeltaY;
		/** @type {number} */
		var stageWidth = com.inq.ui.Stage.getterStageWidth() + growDeltaX;

		// This is short solution for RTDEV-7404
		// did not change div.width because of concern of side effects in mobile.
		// div.width's value is 0.
		if (com.inq.utils.Util.getConfig("divSkin", false) && com.inq.utils.Capabilities.isMobile())	{
			stageWidth = Std.parseInt(inqFrame.frameElement.style.width) + Std.parseInt(cntr.styles.width);
		}

		com.inq.flash.client.control.XFrameWorker.setPersistentState(layerID,true,updateCookies);
		com.inq.flash.client.control.XFrameWorker.resizeStage(stageWidth, stageHeight);
		cntr.setVisible(true);
		if(layerID == "Chat") {
			com.inq.flash.client.chatskins.SkinControl.kickOffChat();
		}
	}
    com.inq.flash.client.chatskins.SkinControl.fixChatOnPanelOpenClose(layerID, true, panelHandler);

	// TODO this should be a library function.
	function getBrowserAccessKey() {
		var accessKey = "Alt";
		if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
			accessKey = "Shift Alt";
		} else if ((navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 &&  navigator.userAgent.indexOf('Android') == -1) && navigator.platform.toUpperCase().indexOf('MAC')>=0 )
		{
			accessKey = "Control";
		}
		return accessKey;
	}
};


/**
 * growXcd
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => updateCookies, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public static function growXcd(layerID:String, updateCookies:Bool):Void
 * @public
 * @static
 * @param {string}  layerID
 * @param {boolean}  updateCookies
 * @param {string} automatonId automaton id that run command
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.growXcd = function (layerID, updateCookies, automatonId) {
	var initiator = {type: 'automaton', id: automatonId}; 
	com.inq.flash.client.control.XFrameWorker.showLayer(layerID, false, null, null, updateCookies, initiator);
};


/**
 * shrink
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => updateCookies, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function shrink(layerID:String, ?updateCookies:Bool=true):Void
 * @public
 * @static
 * @param {string}  layerID 
 * @param {boolean}  updateCookies 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.shrink = function(layerID,updateCookies) {
    var panelHandler =  com.inq.flash.client.chatskins.SkinControl.initializePanelHandler(layerID, false);
    if(updateCookies == null) updateCookies = true;
	haxe.Log.trace("XFrameWorker.shrink(" + layerID + ", " + Std.string(updateCookies) + ") entered",{ fileName : "XFrameWorker.hx", lineNumber : 226, className : "com.inq.flash.client.control.XFrameWorker", methodName : "shrink"});
	/** @type {com.inq.ui.Container} */ 
	var cntr;
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication(layerID)) {

		var msgVideoClose = com.inq.utils.Util.getConfig("msgVideoClose", ""); /* @type {string} */
		com.inq.aria.AriaMsg.addAriaMsg(msgVideoClose);

		cntr = Application.application.getMxmlItem(layerID);
		/** @type {?number} */
		var growDeltaX = 0;
		/** @type {?number} */
		var growDeltaY = 0;
		if(cntr.getStyle("visibility") != "collapse") {
			/** @type {?string} */
			var st = cntr.getStyle("height");
			if(st != null && st != "") growDeltaY = cntr.getHeight();
			st = cntr.getStyle("width");
			if(st != null && st != "") growDeltaX = cntr.getWidth();
		}
		cntr.initStyle("visible","false");
		cntr.initStyle("visibility","collapse");
		if (Application.application.sendMessageWhenShowHideLayerFlag === true) {
			var appCont = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
			var loc = appCont.appendSentText(com.inq.flash.client.control.XFrameWorker.doIFrameNotification, -1);
			var message = new com.inq.flash.client.data.ChatCommunicationMessage(appCont.chat, com.inq.flash.client.control.XFrameWorker.doIFrameNotificationToAgent);
			if (com.inq.flash.client.control.XFrameWorker.doIFrameNotification.trim() === "") {//if msg to client is empty, then hide it from CI
				message.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT, "0");
				message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA_HIDDEN_FOR_CUSTOMER, "true");
			}
			appCont.sendChatCommunicationMessage(message, loc);
			Application.application.sendMessageWhenShowHideLayerFlag = false;
		}
		if (!com.inq.flash.client.control.MinimizeManager.isMinimized()) {
			/** if minimized then will call after restore (please see {@link MinimizeManager#actionRestore}) */
			Application.application.resize();
		}
		/** @type {number} */
		var stageHeight = com.inq.ui.Stage.getterStageHeight() - growDeltaY;
		/** @type {number} */
		var stageWidth = com.inq.ui.Stage.getterStageWidth() - growDeltaX;
		com.inq.flash.client.control.XFrameWorker.resizeStage(stageWidth, stageHeight);

		if (com.inq.aria.ModalWindow.isCircularTabbingEnabled) {
			com.inq.aria.ModalWindow.setCircularModalWindow();
		}

		if (!com.inq.flash.client.control.MinimizeManager.isMinimized()) {
			com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField();
		}
		com.inq.flash.client.control.XFrameWorker.setPersistentState(layerID, false, updateCookies);
        com.inq.flash.client.chatskins.SkinControl.fixChatOnPanelOpenClose(layerID, false, panelHandler);
	}
};

/**
 * Is used to setup parameters that will be used to engage the chat on first customer message.
 *
 * @public
 * @static
 * @param {Object} chatParams - parameters to engage the chat
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.setEngageParameters = function (chatParams) {
    if (typeof chatParams != "object") {
        chatParams = com.inq.flash.client.control.XFrameWorker._preparingChatParameters.apply(null, arguments);
    }
    chatParams["agentOutcome"] = com.inq.flash.client.control.XFrameWorker.DO_NOT_DISPLAY_IN_CI + com.inq.flash.client.control.XFrameWorker.findCustomerName(chatParams["agentOutcome"]);

	/*RTDEV-19187 - Remove any circular modal window set by ACIF before engaging chat*/
	com.inq.flash.client.control.XFrameWorker.removeCircularModalWindow();

    /*RTDEV-20032 - Chat auto close due to no customer initial activity*/
    if(com.inq.flash.client.chatskins.SkinControl.getApplicationController().prepareEngageChat(chatParams)){
        com.inq.flash.client.chatskins.SkinControl.onChatEngaged();
	};
};

/**
 * Is used to engage the chat with specified parameters.
 *
 * @public
 * @static
 * @param {Object} chatParams - parameters to engage the chat
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.engageChat = function (chatParams) {
	if (typeof chatParams != "object") {
		chatParams = com.inq.flash.client.control.XFrameWorker._preparingChatParameters.apply(null, arguments);
	}
	chatParams["agentOutcome"] = com.inq.flash.client.control.XFrameWorker.DO_NOT_DISPLAY_IN_CI + com.inq.flash.client.control.XFrameWorker.findCustomerName(chatParams["agentOutcome"]);

    /*RTDEV-19187 - Remove any circular modal window set by ACIF before engaging chat*/
	com.inq.flash.client.control.XFrameWorker.removeCircularModalWindow();
	if(com.inq.flash.client.control.XFrameWorker.redirectToNativeSDK(chatParams)) {return;}

    /*RTDEV-20540 - Chat auto close due to no customer initial activity*/
    if(com.inq.flash.client.chatskins.SkinControl.getApplicationController().engageChat(chatParams)){
        com.inq.flash.client.chatskins.SkinControl.onChatEngaged();
	}
};

com.inq.flash.client.control.XFrameWorker.redirectToNativeSDK = function(chatparams) {
	if(typeof window.top.NuanIJSFBridge != "undefined" || com.inq.utils.Capabilities.getIOSNativeSDKInstance()) {
		chatparams["vidyoHost"] = com.inq.utils.Util.getConfig("vidyoHost", "prod.vidyo.io");
		chatparams["appKeyId"] = com.inq.utils.Util.getConfig("appKeyId", "123");
		chatparams["custName"] =  com.inq.flash.client.control.FlashVars.getCustomerName();
		com.inq.flash.client.chatskins.SkinControl.removeModalWindow();
		if (com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtnAdded) {
			com.inq.flash.client.control.MinimizeManager.dummyRestoreBtn.remove();
		}

		com.inq.flash.client.control.MinimizeManager.Close();
		com.inq.flash.client.chatskins.ScrollMonitor.Close();
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.Close();
		com.inq.stage.ViewportMgr.close();

		com.inq.flash.client.chatskins.SkinControl.HideClientDecorations();
		com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
		com.inq.flash.client.chatskins.SkinControl.StopTimer();
		com.inq.aria.ModalWindow.removeCircularModalWindow();
		Application.application.close();
		com.inq.flash.client.control.FlashPeer.launchNativeSDK(chatparams);


		return true;
	}

	return false;
};


/**
 * Enable/disable circular tabbing in chat window
 * @param {boolean} enable
 */
com.inq.flash.client.control.XFrameWorker.setCircularTabbing = function (enable) {
    if (enable) {
		com.inq.flash.client.control.XFrameWorker.setCircularApplication();
    } else {
        com.inq.flash.client.control.XFrameWorker.removeCircularModalWindow();
    }
};

/**
 * This is a packager of parameters from old implementation of XFrameWorker.engageChat()
 * @see com.inq.flash.client.control.XFrameWorker.engageChat
 *
 * @param {string} text
 * @param {string} clientText
 * @param {string} agentAttrs
 * @param {string} businessUnitID
 * @param {string} phone
 * @param {string} agentGroupId
 * @param {string=} scriptTreeId
 * @param {string=} publicUserId
 * @param {string=} automatonId
 * @param {string=} automatonFields
 * @return {Object}
 */
com.inq.flash.client.control.XFrameWorker._preparingChatParameters = function (text, clientText, agentAttrs, businessUnitID, phone, agentGroupId, scriptTreeId, publicUserId, automatonId, automatonFields) {
	return {
		"agentOutcome": text,
		"clientOutcome": clientText,
		"agentAttrs": agentAttrs,
		"businessUnitID": businessUnitID,
		"phone": phone,
		"agentGroupId": agentGroupId,
		"scriptTreeId": scriptTreeId,
		"publicUserId": publicUserId,
		"automatonId": automatonId,
		"automatonFields": automatonFields
	};
};

/**
 * Get chat connection to CR status.
 * Used by ACIF automaton to check chat connection status
 * in case if chat engagement process was interrupted by page landing or page refresh.
 *
 * @returns {boolean} true if CI connect and can communicate with CR
 */
com.inq.flash.client.control.XFrameWorker.isChatConnected = function () {
	// check connection restored or will be restored because we have message count in cookie great than 0 to
	// fix race condition when automaton initialize more quickly than chat reconnection.
	var skinControl = com.inq.flash.client.chatskins.SkinControl;
	var msgRereadLmt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	if (skinControl.getIsPersistentChat() &&
		msgRereadLmt < skinControl.applicationController.msgcntAtEntry) {
		msgRereadLmt = skinControl.applicationController.msgcntAtEntry;
	}
	return skinControl.applicationController.isConnected() || msgRereadLmt > 0;
}

/**
 * findCustomerName
 *
 * find a possible Customer Name added into the text string and remove it.
 * This Customer Name will be used as Customer Label in Transcript.
 *
 * @public
 * @static
 * @param {string}  aStr
 * @return {string}
 */
com.inq.flash.client.control.XFrameWorker.findCustomerName = function (aStr) {
	var cdnStr;
	var myregex = new RegExp("CustomerDisplayName: (.*)\n", 'i');

	if(myregex.test(aStr)) {
		cdnStr = myregex.exec(aStr);
		if(cdnStr.length == 2 && cdnStr[1] != "") {
			com.inq.flash.client.control.FlashVars.setCustomerName(cdnStr[1], true);
		}
		aStr = aStr.replace(myregex,"");
	}

	return aStr;
};

/**
 * preparingClosingChat - is used to close session and stop the chat activity
 *
 * This is the prototype of the function that acif must be used
 * to correctly close the chat session at the time the thank-you image is displayed.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.preparingClosingChat = function() {
	com.inq.flash.client.chatskins.SkinControl.preparingClosingChat();
};

/**
 * closeChat - is used to close chat from client side.
 */
com.inq.flash.client.control.XFrameWorker.closeChat = function () {
	if (!com.inq.flash.client.chatskins.SkinControl.isChatSessionEnded() || Application.application.getVisible()) {
		com.inq.flash.client.chatskins.SkinControl.actionCloseChat();
	}
};

/**
 * Set automaton data map by automaton action.
 * Note: automaton data which is set by BR will be replaced.
 *
 * @param {string}  json data to share (stringified JSON)
 */
com.inq.flash.client.control.XFrameWorker.setAutomatonDataMapXcd = function (json) {
	com.inq.flash.client.control.FlashVars.setAutomatonSpecData(json);
	if (com.inq.flash.client.control.XFrameWorker.isChatConnected()) {
		var message = new com.inq.flash.client.data.ChatAutomatonDataMapMessage(com.inq.flash.client.control.FlashVars.getChatID(), json);
		com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendMessage(message);
	}
};

/**
 * isDisplayInCI
 * Determines if the given text contains a token that will disallow displaying in the CI.
 * Kludgy addition for SprintCare launch MAINT27-580
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * public static function isDisplayInCI(text:String)
 * @public
 * @static
 * @param {string}  text 
 * @return {boolean}
 */
com.inq.flash.client.control.XFrameWorker.isDisplayInCI = function(text) {
	return text.indexOf(com.inq.flash.client.control.XFrameWorker.DO_NOT_DISPLAY_IN_CI) < 0;
};


/**
 * setPersistentState
 *
 * $type TFun([{ name => id, t => TInst(String,[]), opt => false },{ name => show, t => TEnum(Bool,[]), opt => false },{ name => updateCookies, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * private static function setPersistentState(id:String, show:Bool, updateCookies:Bool)
 * @private
 * @static
 * @param {string}  id 
 * @param {boolean}  show 
 * @param {boolean}  updateCookies 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.setPersistentState = function(id,show,updateCookies) {
	haxe.Log.trace("XFrameWorker.setPersistentState entered: layer '" + id + "' = " + Std.string(show) + ", updateCookies=" + Std.string(updateCookies),{ fileName : "XFrameWorker.hx", lineNumber : 263, className : "com.inq.flash.client.control.XFrameWorker", methodName : "setPersistentState"});
	/** @type {Object} */ 
	var xf = com.inq.flash.client.control.PersistenceManager.GetValue(XFRAMES,{ });
	if (show) {
		xf[id] = "1";
	} else {
		xf[id] = "0";
		//if container was hidden, need to hide all child elements
		var container = Application.getContainer(id);
		setPersistenceStateDeep(container, "0", xf);
	}

    if(id.match(/[^0-9a-zA-Z]/) && typeof console != "undefined") {
        console.warn("(Warning!!!) XFrame name " + id + " contains special symbols and will not be parsed in cookies! Please change XFrame name");
    }
	/*  force=true - to update cookies, otherwise we must clone "xf" object to pass through the equality check in PersistenceManager.SetValue(). */
	com.inq.flash.client.control.PersistenceManager.SetValue(XFRAMES, xf, true, updateCookies);

	function setPersistenceStateDeep(container, show, map) {
		if (container.contains && container.contains.size() > 0) {
			for (var i = 0; i < container.contains.size(); i++) {
				var child = container.contains[i];
				if (map[child.styles["id"]]) {
					map[child.styles["id"]] = show;
				}
				setPersistenceStateDeep(child, show, map);
			}
		}
	}
};


/**
 * Resize chat window if chat is not minimize.
 *
 * @param {number}  stageWidth - new width of chat window 
 * @param {number}  stageHeight - new height of chat window
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.resizeStage = function (stageWidth, stageHeight) {
	if (com.inq.flash.client.control.MinimizeManager.isMinimized()) {
		return;
	}
	Application.ResizeStage(stageWidth,stageHeight);/* Application's ResizeStage sets the cookie correctly and checks for minimum sizes */
	Application.application.resize();
	//Adjust chat window position
	com.inq.flash.client.chatskins.ScrollMonitor.moveChat();
	com.inq.flash.client.control.XFrameWorker.hideLoadingButton();
};

/**
 * Move chat window.
 *
 * @param location the position specifier for where to position the client skin.
 * @param x the horizontal position of left-top corner of the chat window.
 * @param y the vertical position of left-top corner of the chat window.
 * Parameters x and y used if {@code location) is ABSOLUTE or RELATIVE.
 * Possible values of location are:
 * "UPPER_CENTER", "TOP_CENTER"
 * "UPPER_RIGHT", "TOP_RIGHT"
 * "UPPER_LEFT", "TOP_LEFT"
 * "CENTER_LEFT"
 * "CENTER_RIGHT"
 * "LOWER_LEFT", "BOTTOM_LEFT"
 * "LOWER_CENTER", "BOTTOM_CENTER"
 * "LOWER_RIGHT", "BOTTOM_RIGHT"
 * "POP_UNDER_CENTER"
 * "ABSOLUTE"
 * "RELATIVE"
 * "CENTER"
 */
com.inq.flash.client.control.XFrameWorker.moveStage = function(location, x, y) {
	var area = Application.GetArea();
	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();
	var pos = Application.calcChatLocation(area.w, area.h, x, y, location);

	if (pos) {
		var iframe = window.frameElement;
		iframe.style.left = Std.string(pos.x) + "px";
		iframe.style.top = Std.string(pos.y) + "px";
		Application.initialXPos = pos.x - vp.x;
		Application.initialYPos = pos.y - vp.y;
		Application.MoveStage(pos.x, pos.y);
	} else {
		haxe.Log.trace("XFrameWorker.moveStage('" + location + "', ...): can't move persistent chat window");
	}
};


/**
 * syncLayer
 * Synchronise the layer to a given cache ID
 *
 * $type TFun([{ name => layerID, t => TInst(String,[]), opt => false },{ name => cacheId, t => TMono(<mono>), opt => false },{ name => dtid, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * public static function syncLayer(layerID:String, cacheId, ?dtid:String=null):Void
 * @public
 * @static
 * @param {string}  layerID - the identifier for the layer as defined in the MXML 
 * @param {TMono(<mono>)}  cacheId 
 * @param {string}  dtid - (optional) the id of the decision tree 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.syncLayer = function(layerID,cacheId,dtid) {
	/** @type {com.inq.ui.XFrame} */
	var cntr;
	/** @type {number} */
	var indx;
	/** @type {Object} */
	var map = { };


	if(com.inq.flash.client.chatskins.SkinControl.isInApplication(layerID)) {
		/** @type {string} */
		var name;
		/** @type {?string} */
		var valu;
		/* Get XFrame from the supplied layerID */
		cntr = Application.application.getMxmlItem(layerID);
		
		/* if there is no container or the container has no source then return */
		if(cntr == null || cntr.src == null) return;
		
		/* If there is no query string then there is no point to continue */
		indx = cntr.src.indexOf("?");
		if(indx == -1) return;
		
		/* Isolate the query and the url */
		/** @type {string} */
		var params = cntr.src.substr(indx + 1);
		/** @type {string} */
		var url = cntr.src.substr(0,indx + 1);

		/* Separate the name value pairs and make a map of the names and values */
		/** @type {Array} */
		var nameValuePairs = params.split("&");
		for (var i = 0; i < nameValuePairs.length; i++) {
			/** @type {string} */
			var namevalue = nameValuePairs[i];
			indx = namevalue.indexOf("=");
			if(indx != -1) {
				name = HxOverrides.substr(namevalue,0,indx);
				valu = HxOverrides.substr(namevalue,indx + 1,null);
			} else {
				name = namevalue;
				valu = null;
			}
			map[name] = valu;
		}
		
		/* Add the new dtid and the cache id to the map */
		if(dtid != null) map["dtid"] = dtid;
		if(cacheId != null) map["cacheid"] = cacheId;
		
		/* Build a new query string */
		/** @type {string} */
		var query = "";
		/** @type {Array} */
		var keyz = Reflect.fields(map);
		for (var j = 0; j < keyz.length; j++) {
			name = keyz[j];
			valu = map[name];
			if (j != 0) {
				query += "&";
			}
			if (valu != null) {
				query += name + "=" + valu;
			} else {
				query += name;
			}
		}
		
		/* redefine the src */
		url += query;
		com.inq.flash.client.control.PersistenceManager.SetValue(XFORM_QUERY_STRING, query);
		cntr.setSrc(url);
		
		/* If visible then load the new query string
		 * else show the layer, it will load the new query string
		 */
		if(cntr.getVisible()) cntr.loadContent(); else com.inq.flash.client.control.XFrameWorker.showLayer(layerID);/* show layer loads content */
	}
};


/**
 * onCookiesCommitted
 *
 * $type TFun([{ name => handler, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function onCookiesCommitted(handler:String):Void
 * @public
 * @static
 * @param {string}  handler 
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.onCookiesCommitted = function(handler) {
	com.inq.flash.client.control.FlashPeer.onCookiesCommitted(handler);
};


/**
 * ariaHelpOnLoadingButton
 *
 * xFrame generally takes longer and loading message is displayed,
 * 	for accessibility, the message should be spoken by a screen reader.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.ariaHelpOnLoadingButton = function() {
	// loading message for CATO
	var xframeloadingDiv = Application.application.getMxmlItem("xframeloading");
	var _aria = com.inq.aria.AriaMsg;

	if (xframeloadingDiv && xframeloadingDiv._visible == true) {
		var loadingLabel = Application.application.getButton("btnPleaseWait").label;

		if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
			com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId = window.setInterval(function () {
				var btnPW = Application.application.getButton("btnPleaseWait")._img;
				_aria.addAriaMsg((loadingLabel !== null
					? loadingLabel
					: "Chat is loading ... Please wait."));
				btnPW.focus();
				if(com.inq.flash.client.control.XFrameWorker.xframeLoadingIntIdCount>5) {
					clearInterval(com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId);
					com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId = -1;
				}
				com.inq.flash.client.control.XFrameWorker.xframeLoadingIntIdCount++;
			}, 1000);
		}
		else {

			_aria.addAriaMsg((loadingLabel !== null
				? loadingLabel
				: "Chat is loading ... Please wait."));

		}
	}
};

/**
 * hideLoadingButton
 *
 * Once xframe is loaded, loading message is hidden.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.XFrameWorker.hideLoadingButton = function() {
	var xframeloadingDiv = Application.application.getMxmlItem("xframeloading");
	if(xframeloadingDiv && xframeloadingDiv._visible == true) {
		xframeloadingDiv.setVisible(false);
		com.inq.aria.AriaMsg.clearAriaMsg();
		if(com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId && com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId > -1) {
			clearInterval(com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId);
		}
	}
};

/**
 * Include given div object into Circular Modal Window 
 * @param {?HTMLElement} [div=Application.application.getPrimaryObject()] - Container, which need to include into circular tabbing
 * @param {?HTMLElement} [firstEl] - Upper boundary of circular tabbing in container
 * @param {?HTMLElement} [lastEl] - Bottom boundary of circular tabbing in container
 * @return {boolean} - true if there is no exception
 */
com.inq.flash.client.control.XFrameWorker.setCircularModalWindow = function (div, firstEl, lastEl) {
	return com.inq.aria.ModalWindow.setCircularModalWindow(div, firstEl, lastEl);
};

/**
 * Set Circular Modal Window on application element.
 * @return {boolean}
 */
com.inq.flash.client.control.XFrameWorker.setCircularApplication = function () {
		com.inq.aria.ModalWindow.setCircularApplication();
};

/**
 * Remove Circular Modal Window
 */
com.inq.flash.client.control.XFrameWorker.removeCircularModalWindow = function () {
    com.inq.aria.ModalWindow.removeCircularModalWindow();
};

com.inq.flash.client.control.XFrameWorker.isCircularTabbingEnabled = function () {
	return com.inq.aria.ModalWindow.isCircularTabbingEnabled;
};


/**
 * reset the scrolling values for the new automation screen
 */
com.inq.flash.client.control.XFrameWorker.transitionPage = function(){
	var xframes = Application.application.getXFrameItems();
	for(var i=0;i<xframes.length;i++) {
		xframes[i].resetScrolling();
	}
};

/** @type {com.inq.flash.client.control.XFrameWorker} */
com.inq.flash.client.control.XFrameWorker.prototype.__class__ = com.inq.flash.client.control.XFrameWorker;
/** @type {string} */
com.inq.flash.client.control.XFrameWorker.DO_NOT_DISPLAY_IN_CI = "<!-- Data Pass -->";
/** @private @static @type {Number} */
com.inq.flash.client.control.XFrameWorker.xframeLoadingIntIdCount = 0;
/** @private @static @type {Number} */
com.inq.flash.client.control.XFrameWorker.xframeLoadingIntId = -1;
/** @private @static @type {String} */
com.inq.flash.client.control.XFrameWorker.doIFrameNotification = "Panel closed";
/** @private @static @type {String} */
com.inq.flash.client.control.XFrameWorker.doIFrameNotificationToAgent = "Panel closed";
